(function() {
  if (window.JomoDeliveryData) return;
  const requests = new Map();
  const selectionKey = 'jomo-delivery-selected-zone-v2';
  const legacySelectionKey = 'jomo-delivery-selected-zone-v1';
  const estimateKey = 'jomo-delivery-estimated-zone-v1';
  const selectionMaxAge = 30 * 24 * 60 * 60 * 1000;
  const estimateMaxAge = 12 * 60 * 60 * 1000;
  let selectedCoverage = null;
  let estimatedCoverage = null;
  const zoneNames = new Set(['Toronto Core', 'Oakville', 'Mississauga', 'Brampton', 'Vaughan', 'Richmond Hill', 'Markham', 'Scarborough']);
  const provinceNames = new Set(['Newfoundland and Labrador', 'Prince Edward Island', 'Nova Scotia', 'New Brunswick', 'Quebec', 'Ontario', 'Manitoba', 'Saskatchewan', 'Alberta', 'British Columbia', 'Yukon', 'Northwest Territories', 'Nunavut']);

  function normalizeCoverage(coverage, savedAt = coverage?.savedAt, maxAge = estimateMaxAge) {
    if (!['local', 'shipping', 'territory', 'outside'].includes(coverage?.service)) return null;
    if (!Number.isFinite(savedAt) || savedAt > Date.now() || Date.now() - savedAt >= maxAge) return null;
    const service = coverage.service;
    const zoneName = service === 'local' && zoneNames.has(coverage.zoneName) ? coverage.zoneName : '';
    const provinceName = service === 'local' ? 'Ontario'
      : service !== 'outside' && provinceNames.has(coverage.provinceName) ? coverage.provinceName : '';
    if (service === 'local' && !zoneName || ['shipping', 'territory'].includes(service) && !provinceName) return null;
    return { service, zoneName, provinceName, savedAt };
  }

  function readSelection(persistent, key = selectionKey, maxAge = selectionMaxAge) {
    try {
      const storage = persistent ? localStorage : sessionStorage;
      const raw = storage.getItem(key);
      const selection = normalizeCoverage(JSON.parse(raw), undefined, maxAge);
      if (raw && !selection) storage.removeItem(key);
      return selection;
    } catch (_error) {
      return null;
    }
  }

  function persistSelection(selection) {
    try {
      localStorage.setItem(selectionKey, JSON.stringify(selection));
    } catch (_error) {
      try {
        sessionStorage.setItem(selectionKey, JSON.stringify(selection));
        sessionStorage.removeItem(legacySelectionKey);
      } catch (_storageError) {}
      return;
    }
    try {
      sessionStorage.removeItem(selectionKey);
      sessionStorage.removeItem(legacySelectionKey);
    } catch (_error) {}
  }

  window.JomoDeliveryData = {
    zoneDisplayName(name) {
      return name === 'Toronto Core' ? 'Toronto' : name;
    },

    getEstimate() {
      let stored = null;
      try {
        stored = normalizeCoverage(JSON.parse(sessionStorage.getItem(estimateKey)));
      } catch (_error) {}
      const memory = normalizeCoverage(estimatedCoverage);
      const estimate = memory && (!stored || memory.savedAt >= stored.savedAt) ? memory : stored;
      return estimate ? { ...estimate } : null;
    },

    setEstimate(estimate) {
      estimatedCoverage = normalizeCoverage(estimate, estimate?.savedAt ?? Date.now());
      try {
        if (estimatedCoverage) sessionStorage.setItem(estimateKey, JSON.stringify(estimatedCoverage));
        else sessionStorage.removeItem(estimateKey);
      } catch (_error) {}
    },

    getSelection() {
      const stored = readSelection(true);
      const candidates = [
        normalizeCoverage(selectedCoverage, undefined, selectionMaxAge),
        stored,
        readSelection(false),
        readSelection(false, legacySelectionKey, estimateMaxAge)
      ];
      selectedCoverage = candidates.reduce((latest, candidate) => (
        candidate && (!latest || candidate.savedAt > latest.savedAt) ? candidate : latest
      ), null);
      if (selectedCoverage && (!stored || selectedCoverage.savedAt > stored.savedAt)) {
        persistSelection(selectedCoverage);
      }
      return selectedCoverage ? { ...selectedCoverage } : null;
    },

    setSelection(selection) {
      selectedCoverage = normalizeCoverage(selection, undefined, selectionMaxAge);
      if (selectedCoverage) {
        persistSelection(selectedCoverage);
        return;
      }
      try {
        localStorage.removeItem(selectionKey);
      } catch (_error) {}
      try {
        sessionStorage.removeItem(selectionKey);
        sessionStorage.removeItem(legacySelectionKey);
      } catch (_error) {}
    },

    loadJson(url) {
      if (!requests.has(url)) {
        // Shared across components: disconnecting one consumer must not abort
        // another consumer's request. Consumers guard their own lifecycle.
        const request = fetch(url, { credentials: 'same-origin' }).then((response) => {
          if (!response.ok) throw new Error(`Delivery zone data returned ${response.status}`);
          return response.json();
        });
        requests.set(url, request);
        request.catch(() => {
          if (requests.get(url) === request) requests.delete(url);
        });
      }
      return requests.get(url);
    }
  };
  window.addEventListener('jomo:delivery-zone-change', (event) => {
    window.JomoDeliveryData.setSelection(event.detail);
  });
})();
